var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import Row from "bootstrap-vue/es/components/layout/row";
import Col from "bootstrap-vue/es/components/layout/col";
import PostalAddress from "../Components/PostalAddress.vue";
import Card from "../Components/Card.vue";
import BingMap from "../Components/BingMap.vue";
import Coordinators from "../Components/Coordinators.vue";
import PageLinkList from "../Components/PageLinkList.vue";
var GeneralInformation = /** @class */ (function (_super) {
    __extends(GeneralInformation, _super);
    function GeneralInformation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ type: String, default: "dddd, LL" })
    ], GeneralInformation.prototype, "dateFormat", void 0);
    __decorate([
        Prop({ type: Object })
    ], GeneralInformation.prototype, "location", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], GeneralInformation.prototype, "locationLinks", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], GeneralInformation.prototype, "nearby", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], GeneralInformation.prototype, "information", void 0);
    __decorate([
        Prop({ type: Object })
    ], GeneralInformation.prototype, "travelInformation", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], GeneralInformation.prototype, "coordinators", void 0);
    __decorate([
        Prop({ type: Object })
    ], GeneralInformation.prototype, "housing", void 0);
    __decorate([
        Prop({ type: Object })
    ], GeneralInformation.prototype, "tuition", void 0);
    __decorate([
        Prop({ type: Object })
    ], GeneralInformation.prototype, "sessions", void 0);
    __decorate([
        Prop({ type: Object })
    ], GeneralInformation.prototype, "extraCurricular", void 0);
    __decorate([
        Prop({ type: Object })
    ], GeneralInformation.prototype, "childrensProgram", void 0);
    __decorate([
        Prop({ type: String })
    ], GeneralInformation.prototype, "generalEmail", void 0);
    __decorate([
        Prop({ type: String })
    ], GeneralInformation.prototype, "emailSubject", void 0);
    __decorate([
        Prop({ type: String })
    ], GeneralInformation.prototype, "generalPhoneNumber", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], GeneralInformation.prototype, "resources", void 0);
    GeneralInformation = __decorate([
        Component({
            name: "GeneralInformation",
            components: {
                PostalAddress: PostalAddress,
                Card: Card,
                BingMap: BingMap,
                Coordinators: Coordinators,
                PageLinkList: PageLinkList,
                "b-row": Row,
                "b-col": Col
            }
        })
    ], GeneralInformation);
    return GeneralInformation;
}(Vue));
export default GeneralInformation;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Colloquium/GeneralInformation.vue
// module id = 889
// module chunks = 0